import { Features } from '@lessonPlanner/constants';

import { NON_CURRICULUM_SPECIFIC_FEATURES } from '../constants/portalFeatures';

export const isNonCurriculumSpecific = (featureKey: Features): boolean =>
  NON_CURRICULUM_SPECIFIC_FEATURES.includes(featureKey);
